import { Component, OnInit } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { UserService } from "../../../../../shared";
import { SysAdminService } from "../../../services/sysadmin.service";
import { School } from "../../../user-administration/shared/School";
import { UserGroupRequestModel } from "../../../user-administration/shared/UserGroupRequestModel";
import { ChangeIntsModel } from "../../ChangeIntsModel";

@Component({
	selector: "app-mscadd-user-group",
	templateUrl: "./mscadd-user-group.component.html",
	styleUrls: ["./mscadd-user-group.component.css"],
})
export class MSCAddUserGroupComponent implements OnInit {
	constructor(
		private ref: DynamicDialogRef,
		private dialogConfig: DynamicDialogConfig,
		private sysAdminService: SysAdminService,
		private confirmationService: ConfirmationService,
		private userService: UserService
	) {}

	ngOnInit(): void {
		this.user = this.userService.getCurrentUser();

		//Get data from parent
		this.SchoolGroupID = this.dialogConfig.data.SchoolGroupID;
		this.SelectedUserGroups = this.dialogConfig.data.SelectedUserGroups;

		this.UpdateSelected();

		//Get Data from DB

		//Get school list first then the method gets
		//user groups
		this.loadSchoolList();
		// this.loadUserGroupList();
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////

	user: any;

	//Data from Parent
	lstSchool: any = [];
	SchoolGroupID: any;

	//Table Data
	lstUserGroups: any = [];
	SelectedUserGroups: any = [];
	OriginalUserGroups: any = [];

	lstUserLevelDesc: any = [];
	lstActive: any = [];

	pagerows: any = 5;
	pagefirst: any = 0;

	cols = [
		{ field: "UserGroupCD", header: "Code" },
		{ field: "UserGroupDesc", header: "Description" },
		{ field: "UserLevelDesc", header: "User Level" },
		{ field: "Active", header: "Active" },
	];

	loading: any = false;

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////

	//
	// Load schools for school container, then use to get
	// possible user groups
	//

	private loadSchoolList() {
		this.loading = true;

		var result = this.sysAdminService.SchoolGroupGetSchools(this.SchoolGroupID);
		result.subscribe(
			(response) => {
				this.lstSchool = response;
				this.loadUserGroupList();
			},
			(error) => {}
		);
	}

	loadUserGroupList() {
		//
		// Get defaults for user if no schools are added
		//

		if (this.lstSchool.length == 0) {
			this.lstSchool.unshift({
				SchoolID: 0,
				SchoolName: "N/A",
				SchoolNumber: 0,
			});
		}

		//
		// Get list of user groups to add based on
		// schools in the school container
		//

		//Create list of formatted school objects
		let FormattedSchools: School[] = [];

		for (var i = 0; i < this.lstSchool.length; i++) {
			let val1: School = {
				SchoolID: this.lstSchool[i].SchoolID,
				SchoolName: this.lstSchool[i].SchoolName,
				SchoolNumber: this.lstSchool[i].SchoolID.toString(),
			};

			FormattedSchools = [...FormattedSchools, val1];
		}

		//Create request model w/ formatted list and other data
		let parms: UserGroupRequestModel = {
			UserLevelID: this.user.UserLevelID,
			Active: 2,
			Schools: FormattedSchools,
		};

		var result = this.sysAdminService.UserGroupGetList(parms);
		result.subscribe(
			(response) => {
				this.lstUserGroups = response;

				for (var i = 0; i < this.lstUserGroups.length; i++) {
					var next = this.lstUserGroups[i];
					next.Active = this.ActiveText(next.Active);
				}

				this.lstUserLevelDesc = Array.from(new Set(this.lstUserGroups.map((item: any) => item.UserLevelDesc))).sort();
				this.lstActive = Array.from(new Set(this.lstUserGroups.map((item: any) => item.Active))).sort();
			},
			(error) => {}
		);

		this.loading = false;
	}

	UpdateSelected() {
		this.SelectedUserGroups = this.dialogConfig.data.SelectedUserGroups;
		this.OriginalUserGroups = this.dialogConfig.data.SelectedUserGroups;
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onSelectAll() {}
	onUnselectAll() {}
	onUpdate() {
		//Get rid of containers that are already attached to the User Group
		var UserGroupsToAdd = this.SelectedUserGroups.filter((cont) => this.OriginalUserGroups.indexOf(cont) == -1);

		//Create list of strings
		var lstUserGroupID: number[] = [];

		for (var i = 0; i < UserGroupsToAdd.length; i++) {
			var next = Number(UserGroupsToAdd[i].UserGroupID);
			lstUserGroupID = [...lstUserGroupID, next];
		}

		//Create Query Data
		let data: ChangeIntsModel = {
			MainID: this.SchoolGroupID,
			IDList: lstUserGroupID,
		};

		//Call SP
		var result = this.sysAdminService.SchoolGroupAddUserGroups(data);
		result.subscribe(
			(response) => {
				if (response) {
					//Success Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "User Groups were added successfully",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.ref.close(1);
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could not add user groups to the School Container",
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}
			},
			(error) => {}
		);
	}

	onClose() {
		this.ref.close(0);
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////

	ActiveText(val) {
		return val == 1 ? "Active" : "Inactive";
	}
}
